import { EnumLangs } from '@types';

export const toCapitalize = (text: string): string => {
    return text
        .toLowerCase()
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

export const isEmpty = (obj: Record<string, any>): boolean => {
    return Object.keys(obj).length === 0;
};

export const getTextsByLang = (lang: EnumLangs, texts: any) => {
    const textsByLang = texts?.find((item: any) => item.lang === lang);
    return textsByLang;
};

export const hasSomeValue = (obj: { [key: string]: any }): boolean => {
    return Object.values(obj).some(value => value);
};

export const convertMinutesToHours = (minutes: number): string => {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(remainingMinutes).padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}`;
};

export const dateConvert = (isoString: Date, time?: boolean) => {
    const localTime = new Date(isoString).getTime() + new Date(isoString).getTimezoneOffset() * 60000;
    const date = new Date(localTime);

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear().toString().slice(-2);
    const hour = date.getHours();
    const minutes = date.getMinutes();

    const readableDate = `${day < 10 ? `0${day}` : day}.${month < 10 ? `0${month}` : month}.${year}`;
    const dateAndTime = `${hour < 10 ? `0${hour}` : hour}:${minutes < 10 ? `0${minutes}` : minutes} ${readableDate}`;

    return time ? dateAndTime : readableDate;
};
